import * as actionTypes from '../../types/settings';
import { getSettingsConfig } from '../../../services/endpoints/settings';

/**
 * @function
 * @name getSettingsConfigAction
 * @description Конфиг для страниц
 * @param {object} payload - Объект query листинга(фильтров)
 */
export const getSettingsConfigAction = (payload) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_MAIN_CONFIG });

  try {
    const response = await getSettingsConfig(payload);
    const { data } = response;

    dispatch({
      type: actionTypes.GET_MAIN_CONFIG_SUCCESS,
      data,
    });

    return response;
  } catch (error) {
    dispatch({ type: actionTypes.GET_MAIN_CONFIG_ERROR, error });
    throw error;
  }
};
